import React from 'react';
import MediaQueries from 'react-responsive';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaThreeColImages from 'marketing-website/components/modules/Media/MediaThreeColImages';

import assets from 'marketing-website/configs/pages/features/handoff/assets.js';

export default function Assets() {
  return (
    <Spacing type="padding" size="xl" position="top">
      <Spacing type="padding" sizeM="xl" position="topBottom">
        <PageWrap size="l">
          <Spacing type="padding" size="xl" position="bottom">
            <MediaQueries maxWidth={769}>
              <Image {...assets.assetsFallback} hasShadow={false} />
            </MediaQueries>
            <HeadingBlock
              size="xs"
              justifyContent="center"
              justifyM="start"
              title="Instantly turn designs into code, specs and assets"
              copy={
                <span>
                  Our design handoff tool, puts an end to manual design
                  documentation, PDFs and redlines. Now, all you need for
                  designer developer handoff is a single URL, where they can
                  find everything they need to start building.
                  <br />
                  <br />
                  Handoff generates CSS, Swift and Android XML instantly for
                  designs made within Marvel or Sketch, shaving time off the
                  design to development process.
                </span>
              }
            />
          </Spacing>
        </PageWrap>
        <MediaQueries minWidth={770}>
          <MediaThreeColImages
            radius="none"
            images={assets.assetsBlock}
            fallbackImage={assets.assetsFallback}
          />
        </MediaQueries>
      </Spacing>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/handoff/Assets.js